// Check if hero has dark overlay
var darkOverlay = document.querySelector('.hero.blue')
var bodyClass = document.querySelector('body')

if(darkOverlay){
    bodyClass.classList.add('dark-bg');
}

// Check if hero has no overlay
var noOverlay = document.querySelector('.hero.none')
var Class = document.querySelector('body')

if(noOverlay){
    Class.classList.add('no-bg');
}